/**
 * @Time    : 2024/4/23 17:41
 * @Author  : tlovet
 * @Software: WebStorm
 */

export default {
  'app.common.option': 'Operating',
  'app.common.reload': 'Reload',
  'app.common.refresh': 'Refresh',
  'app.common.detail': 'Detail',
  'app.common.log': 'Log',
  'app.common.add': 'Add',
  'app.common.edit': 'Edit',
  'app.common.create': 'Create',
  'app.common.update': 'Update',
  'app.common.delete': 'Delete',
  'app.common.batchDelete': 'Batch Delete',
  'app.common.import': 'Import',
  'app.common.export': 'Export',
  'app.common.apply': 'Apply',
  'app.common.goBack': 'GoBack',
};
